// A yes / no question inside the wizard (a `call` step's `ask`, leaving with
// unsaved changes, loading over an unsaved record).

import { createPortal } from 'react-dom'
import { tw } from '../../testHooks'
import { button, dialog, overlay } from '../styles'

export default function ConfirmDialog({ message, yes, no, onDone }: {
  message: string
  yes: string
  no: string
  onDone: (ok: boolean) => void
}) {
  const body = (
    <div style={overlay} data-tw-dialog="wizard_confirm">
      <div style={dialog} role="alertdialog" aria-label={message}>
        <div style={{ fontSize: 16, lineHeight: 1.45 }}>{message}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <button type="button" style={button(true)} onClick={() => onDone(false)} {...tw('action', 'cancel')}>{no}</button>
          <button type="button" style={button(true, true)} onClick={() => onDone(true)} {...tw('action', 'confirm')} autoFocus>{yes}</button>
        </div>
      </div>
    </div>
  )
  return typeof document !== 'undefined' ? createPortal(body, document.body) : body
}
